[
  {
    "id": 44,
    "documentId": "aj4nvbetv89mso0x0m36d5op",
    "title": "Top 100 Startup",
    "slug": "top-100-startup-asmi",
    "issuer": "Akselerasi Startup Mahasiswa Indonesia",
    "type": "competition-winner",
    "date": "2020-06-01",
    "description": "Selected as one of the top 100 student startups in Indonesia.",
    "summary": "Top 100 student startup recognition",
    "criteria": null,
    "impact": null,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.527Z",
    "updatedAt": "2025-08-05T12:23:58.527Z",
    "publishedAt": "2025-08-05T12:23:58.530Z",
    "categories": [
      {
        "id": 377,
        "name": "soft-skills"
      }
    ],
    "skills": [],
    "projects": [],
    "experience": [],
    "logo": null,
    "certificate": null,
    "links": [],
    "seo": null
  },
  {
    "id": 46,
    "documentId": "ny6qbu5sw90f21xw8r6dcp2i",
    "title": "Top 20 Startup",
    "slug": "top-20-startup-bekup",
    "issuer": "BAPAREKRAF FOR STARTUP",
    "type": "competition-winner",
    "date": "2020-03-01",
    "description": "Recognized as one of the top 20 startups by BAPAREKRAF.",
    "summary": "Top 20 startup recognition by BAPAREKRAF",
    "criteria": null,
    "impact": null,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.556Z",
    "updatedAt": "2025-08-05T12:23:58.556Z",
    "publishedAt": "2025-08-05T12:23:58.559Z",
    "categories": [
      {
        "id": 379,
        "name": "soft-skills"
      }
    ],
    "skills": [],
    "projects": [],
    "experience": [],
    "logo": null,
    "certificate": null,
    "links": [],
    "seo": null
  },
  {
    "id": 47,
    "documentId": "nbiwxi44kmzhdz8mqi02z0o7",
    "title": "1st Place in Trade and Services",
    "slug": "1st-place-in-trade-and-services-kmi",
    "issuer": "Kewirausahaan Mahasiswa Indonesia Expo",
    "type": "competition-winner",
    "date": "2020-12-01",
    "description": "Won first place in the Trade and Services category at the Indonesian Student Entrepreneurship Expo.",
    "summary": "First place in student entrepreneurship competition",
    "criteria": null,
    "impact": null,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.508Z",
    "updatedAt": "2026-08-05T18:02:35.013Z",
    "publishedAt": "2026-08-05T18:02:35.051Z",
    "categories": [
      {
        "id": 380,
        "name": "soft-skills"
      }
    ],
    "skills": [],
    "projects": [],
    "experience": [],
    "logo": null,
    "certificate": {
      "id": 11,
      "documentId": "qdl860tjks5vz8tjnto009bu",
      "name": "certificate-kmi_expo_2020.jpeg",
      "alternativeText": null,
      "caption": null,
      "focalPoint": null,
      "width": 801,
      "height": 555,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_certificate-kmi_expo_2020.jpeg",
          "hash": "thumbnail_certificate_kmi_expo_2020_9557a389ba",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 225,
          "height": 156,
          "size": 7.11,
          "sizeInBytes": 7108,
          "url": "/uploads/thumbnail_certificate_kmi_expo_2020_9557a389ba.jpeg"
        },
        "medium": {
          "name": "medium_certificate-kmi_expo_2020.jpeg",
          "hash": "medium_certificate_kmi_expo_2020_9557a389ba",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 750,
          "height": 520,
          "size": 49.64,
          "sizeInBytes": 49641,
          "url": "/uploads/medium_certificate_kmi_expo_2020_9557a389ba.jpeg"
        },
        "small": {
          "name": "small_certificate-kmi_expo_2020.jpeg",
          "hash": "small_certificate_kmi_expo_2020_9557a389ba",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 500,
          "height": 346,
          "size": 26.05,
          "sizeInBytes": 26052,
          "url": "/uploads/small_certificate_kmi_expo_2020_9557a389ba.jpeg"
        }
      },
      "hash": "certificate_kmi_expo_2020_9557a389ba",
      "ext": ".jpeg",
      "mime": "image/jpeg",
      "size": 53.87,
      "url": "/uploads/certificate_kmi_expo_2020_9557a389ba.jpeg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "createdAt": "2026-08-05T18:02:23.141Z",
      "updatedAt": "2026-08-05T18:02:23.141Z",
      "publishedAt": "2026-08-05T18:02:23.141Z"
    },
    "links": [],
    "seo": null
  },
  {
    "id": 48,
    "documentId": "meoawprm8gblw19jqwm07plu",
    "title": "Top 50 Funded Startup",
    "slug": "top-50-funded-startup-asmi",
    "issuer": "Akselerasi Startup Mahasiswa Indonesia",
    "type": "competition-winner",
    "date": "2021-12-01",
    "description": "Recognized as one of the top 50 funded student startups in Indonesia.",
    "summary": "Top 50 funded student startup recognition",
    "criteria": null,
    "impact": null,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.470Z",
    "updatedAt": "2026-08-05T18:04:31.984Z",
    "publishedAt": "2026-08-05T18:04:32.027Z",
    "categories": [
      {
        "id": 381,
        "name": "project-management"
      },
      {
        "id": 382,
        "name": "soft-skills"
      }
    ],
    "skills": [],
    "projects": [],
    "experience": [],
    "logo": null,
    "certificate": {
      "id": 12,
      "documentId": "pl71qnngwrudkv5yl0opvt0h",
      "name": "cerificate-asmi_2021.jpeg",
      "alternativeText": null,
      "caption": null,
      "focalPoint": null,
      "width": 805,
      "height": 570,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_cerificate-asmi_2021.jpeg",
          "hash": "thumbnail_cerificate_asmi_2021_add2fbbe39",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 220,
          "height": 156,
          "size": 6.66,
          "sizeInBytes": 6664,
          "url": "/uploads/thumbnail_cerificate_asmi_2021_add2fbbe39.jpeg"
        },
        "medium": {
          "name": "medium_cerificate-asmi_2021.jpeg",
          "hash": "medium_cerificate_asmi_2021_add2fbbe39",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 750,
          "height": 531,
          "size": 45.39,
          "sizeInBytes": 45392,
          "url": "/uploads/medium_cerificate_asmi_2021_add2fbbe39.jpeg"
        },
        "small": {
          "name": "small_cerificate-asmi_2021.jpeg",
          "hash": "small_cerificate_asmi_2021_add2fbbe39",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "path": null,
          "width": 500,
          "height": 354,
          "size": 24.54,
          "sizeInBytes": 24544,
          "url": "/uploads/small_cerificate_asmi_2021_add2fbbe39.jpeg"
        }
      },
      "hash": "cerificate_asmi_2021_add2fbbe39",
      "ext": ".jpeg",
      "mime": "image/jpeg",
      "size": 48.65,
      "url": "/uploads/cerificate_asmi_2021_add2fbbe39.jpeg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "createdAt": "2026-08-05T18:04:27.167Z",
      "updatedAt": "2026-08-05T18:04:27.167Z",
      "publishedAt": "2026-08-05T18:04:27.167Z"
    },
    "links": [],
    "seo": null
  }
]
